module.exports = SVGPathData;


/*****************
 ** WEBPACK FOOTER
 ** external "SVGPathData"
 ** module id = 11
 ** module chunks = 0
 **/